// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".socials[data-v-3b13ef34]{display:inline-flex;margin-top:.5em}.socials img[data-v-3b13ef34]{width:60px}.socials .el-button[data-v-3b13ef34]{padding:0;border:none}", ""]);
// Exports
module.exports = exports;
